import { render } from "./add-employee.vue?vue&type=template&id=564d5420"
import script from "./add-employee.vue?vue&type=script&lang=js"
export * from "./add-employee.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__